function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_595",
  "data-name": "Group 595",
  transform: "translate(0 -.041)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2",
  transform: "translate(0 .041)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_122",
  fill: "none",
  d: "M0 0H32V32H0z",
  "data-name": "Rectangle 122",
  transform: "translate(0 .001)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1",
  transform: "translate(4.322 2.664)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  fill: "#fff",
  d: "M17.605 26.025a.567.567 0 0 1 .515.816 3.6 3.6 0 0 1-6.36 0 .567.567 0 0 1 .515-.816zm8.939-3.867a2.223 2.223 0 0 0-.631-2.477l-.621-.539a1.3 1.3 0 0 1-.449-.984v-4.374a9.879 9.879 0 0 0-8.566-9.777V3.34a1.338 1.338 0 1 0-2.675 0v.673a9.878 9.878 0 0 0-8.525 9.772v4.374a1.3 1.3 0 0 1-.449.986l-.621.538a2.241 2.241 0 0 0 1.467 3.934h18.972a2.223 2.223 0 0 0 2.098-1.458zm-18.792-4v-4.374A7.2 7.2 0 0 1 14.94 6.6h.04a7.194 7.194 0 0 1 7.188 7.187v4.374A3.98 3.98 0 0 0 23.3 20.94H6.619a3.98 3.98 0 0 0 1.133-2.782z",
  "data-name": "Path 52",
  transform: "translate(-3.231 -2.002)"
})));

var SvgIconNotification = function SvgIconNotification(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_notification.595a480d.svg";
export { ForwardRef as ReactComponent };